export enum QueryParams {
  query = "query",
}
